export function canAccessBooklet(user) {
  const role = user?.role?.name ?? user?.role ?? user?.roleName;
  return ['admin', 'superadmin', 'manager'].includes(String(role || '').trim().toLowerCase()) ||
    user?.bookletEditorAccess === true;
}